<template>
    <div :class="$style.container"
         id="loading"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-container>
            <div width="360px" id="jurisdiction">
                <div :class="$style.left" style="height: 100%;display: flex;
            flex-direction: column;">
                    <el-row>
                        <el-col>
                            <div style="padding-top: 8px;margin-bottom:30px;font-weight: bold;">辖区设置</div>
                        </el-col>
                    </el-row>
                    <el-row :style="{'height': onoffManager || onoffPrincipal ? '40px': '3px',
                    'margin-bottom' : onoffManager || onoffPrincipal ? '5px': '0' }">
<!--                        <el-col :span="10" style="border: 1px solid transparent;">-->
<!--                            <el-button v-if="styleA" type="success" style="background: #ff9901;border: 1px solid-->
<!--                            #FF9901" @click="jurisdictionEffect() "-->
<!--                                       icon="el-icon-folder-delete"-->
<!--                                       size="small">辖区生效-->
<!--                            </el-button>-->
<!--                            <el-dropdown v-if="styleA2" style="line-height:34px " trigger="click">-->
<!--                                  <span class="el-dropdown-link" style="color: #FF9901;">-->
<!--                                    2019年11月<i class="el-icon-caret-bottom el-icon&#45;&#45;right"></i>-->
<!--                                  </span>-->
<!--                                <el-dropdown-menu slot="dropdown">-->
<!--                                    <el-dropdown-item class="clearfix">-->

<!--                                    </el-dropdown-item>-->
<!--                                    <el-dropdown-item class="clearfix">-->

<!--                                    </el-dropdown-item>-->
<!--                                </el-dropdown-menu>-->
<!--                            </el-dropdown>-->
<!--                        </el-col>-->
<!--                        <el-col :span="7" style="border: 1px solid transparent;">-->
<!--                            <div align="right">-->
<!--                                <el-button v-if="styleA" type="danger" style="background: #4A90E2;-->
<!--                                border: 1px solid #4A90E2"-->
<!--                                           icon="el-icon-download"-->
<!--                                           size="small"-->
<!--                                           @click="importExport"-->
<!--                                >-->
<!--                                    导入导出-->
<!--                                </el-button>-->
<!--                            </div>-->
<!--                        </el-col>-->
<!--                        <el-col :span="7" style="border: 1px solid transparent;">-->
<!--                            <div align="right">-->
<!--                                <el-button-->
<!--                                        :disabled="saveOff" type="success"-->
<!--                                        v-if="styleA" @click="addJurisdiction()"-->
<!--                                        icon="el-icon-plus" size="small">-->
<!--                                    新增辖区-->
<!--                                </el-button>-->
<!--                                <el-button v-if="styleA2" @click="modeljurisdictionExport = true" type="danger"-->
<!--                                           style="background: #4A90E2;-->
<!--                                border: 1px solid #4A90E2;float: right" icon="el-icon-download"-->
<!--                                           size="small"-->
<!--                                >-->
<!--                                    数据导出-->
<!--                                </el-button>-->
<!--                            </div>-->
<!--                        </el-col>-->
                        <el-button-group>
                            <el-button @click="init('management')"
                                       v-if="onoffManager"
                                       :class="class_active ? 'btn_active' : 'btn_inactive'"
                                       style="width: 180px">我管理的辖区</el-button>
                            <el-button
                                        :class="class_active ? 'btn_inactive' : 'btn_active'"
                                        @click="init('principal')"
                                       v-if="onoffPrincipal"
                                       style="width: 180px">我负责的辖区</el-button>
                        </el-button-group>
                    </el-row>
                    <!--                    <el-row style="margin-top: 20px">-->
                    <!--                        <el-col :span="24">-->
                    <!--                            <el-button class="el-icon-arrow-left"-->
                    <!--                                       style="margin: 0;border-radius:0;width: 59px;">-->
                    <!--                            </el-button><el-date-picker-->
                    <!--                                    prefix-icon=" "-->
                    <!--                                    clear-icon=""-->
                    <!--                                    id="inputData"-->
                    <!--                                    style="margin: 0;width: 240px;"-->
                    <!--                                    v-model="dataTime"-->
                    <!--                                    type="month"-->
                    <!--                                >-->
                    <!--                            </el-date-picker><el-button class="el-icon-arrow-right"-->
                    <!--                                                        style="border-radius:0;width:60px;">-->
                    <!--                            </el-button>-->
                    <!--                        </el-col>-->

                    <!--                    </el-row>-->
                    <el-row id="el-rowInput">
                        <el-col>
                            <el-autocomplete
                                    style="text-align:center"
                                    id="inputSeach"
                                    v-model="input"
                                    placeholder="请输入辖区名字进行快速检索 "
                                    :fetch-suggestions="search"
                                    @select="handleSelect"
                                    :class="$style.search">

                    <span slot-scope="{ item }">
                        <span style="margin-left: 21px;font-size: 14px;color: #555555">{{item.territory_name}}</span>
                    </span>

                            </el-autocomplete>
                        </el-col>
                    </el-row>
                    <div ref="scrollbar" id="treeDiv"
                         style="border: 1px solid #dedede;height: 90%;border-top: none;flex-grow: 1;overflow: auto" >
                        <el-tree
                                lazy
                                :load="loadNode"
                                ref="menusTreeJur"
                                :data="folderArry"
                                @node-click="handleNodeClick"
                                :props="defaultProps"
                                node-key="territory_id"
                                :highlight-current="true"
                                :expand-on-click-node="false"
                                :auto-expand-parent="true"
                                @node-expand="handleNodeExpand"
                                :default-checked-keys="sonNodeKey"
                        >
                     <span style="font-size: 16px" slot-scope="{ node, data }">

                     <span style="display: inline-block;width: 20px;height: 20px;margin: 0 10px 0 10px;">
                         <img style="line-height: 20px" :src="node.data.territory_type =='ENDPOINT'?icon[1]:icon[0]"
                              alt=" "/>
                     </span>
                        <span v-if="node.data.territory_type !='ENDPOINT'"
                              style="line-height: 20px;height: 20px;display: inline-block;">{{node.data
                            .territory_name}}</span>
                        <span v-if="node.data.territory_type =='ENDPOINT'" style="line-height: 20px;height: 20px;display: inline-block;">{{node.data
                            .territory_name}}&nbsp;&nbsp;&nbsp;<span v-if="node.data.territory_code != ''">({{node
                            .data.territory_code}})</span></span>
                    </span>
                        </el-tree>

                    </div>
                </div>
            </div>
            <div style="height: 2%"></div>
            <el-main style="position: relative;padding-right: 0">
<!--                <div style="position: absolute;left: 50%;margin-left: -334px;top: 0;z-index: 100">-->
<!--                    <el-button-group>-->
<!--                        <el-button @click="clickTab('inactive')"-->
<!--                                   style="color: #409EFF;border-color:#c6e2ff;-->
<!--                                        background-color: #ecf5ff;width: 154px">尚未生效的辖区</el-button>-->
<!--                        <el-button @click="clickTab('active')">已生效的辖区管理</el-button>-->
<!--                    </el-button-group>-->
<!--                </div>-->
                <div :class="$style.right">

                    <div :class="$style.header">
                        <el-row>
                            <el-col>
                                <!--                                <a id="effect" @click.prevent="effectNo()" :class="{styleA : styleA}"-->
                                <!--                                   href="">尚未生效的辖区</a>-->
                                <!--                                <a id="effect2" @click.prevent="effectOff()" :class="{styleA : styleA2}"-->
                                <!--                                   href="">已生效的辖区管理-->
                                <!--                                </a>-->
                                <!--                                <el-button autofocus="false" @click="effectNo" style="margin-right: 0;">尚未生效的辖区-->
                                <!--                                </el-button><el-button-->
                                <!--                                    @click="effectOff"-->
                                <!--                                    style="margin-left: 0">已生效的辖区管理</el-button>-->
                            </el-col>
                        </el-row>
                        <el-row style="height: 56px;overflow: hidden;margin-top: 38px">
                            <el-col style="width: 70%;border: 1px solid transparent;height: 100%">
                                <div v-if="territory_region === '地区'"
                                     style="padding-top: 8px;float: left;height: 100%;width: 100%">
                                    <span style="color: #3b99f7;line-height:50px">{{territory_name}}</span>
                                    <p v-if="territory_level_name != ''" id="regionP"
                                       style="">{{territory_level_name}}
                                    </p>
                                    <span
                                            v-if="salList == 0"
                                            style="display: inline-block;padding: 4px 8px;border-radius: 2px;
                                                color:white;font-size: 12px;
                                                background:#bbbbbb;">无人管理</span>
                                </div>

                                <div v-if="territory_region === '终端'"
                                     style="height: 100%;;overflow: hidden;float: left">
                                    <span style="color: #3b99f7;line-height: 68px">{{territory_name}}
                                        ({{territory_code}})</span>
                                </div>

                                <div v-if="territory_region === '终端'" align="left" style=" height: 100%;color:
                                cornflowerblue;float: left">
                                    <p v-if="owner_name != ''"
                                       style="margin-left: 10px;font-size: 12px;margin-top: 24px;color:#bbbbbb">
                                        <span
                                                style="display: inline-block;padding: 4px 8px;border-radius: 2px;
                                                color:white;
                                                background:#FF9901;">{{owner_name
                                            }}</span>&nbsp;
                                        <span>职务:&nbsp;{{owner_title}}</span>
                                        <span></span>
                                    </p>
                                    <p v-if="owner_name == ''"
                                       style="margin-left: 10px;font-size: 12px;margin-top: 24px;color:#bbbbbb">
                                        <span
                                                style="display: inline-block;padding: 4px 8px;border-radius: 2px;
                                                color:white;
                                                background:#bbbbbb;">无人负责</span>
                                    </p>
                                </div>
                            </el-col>

                            <el-col style="width:30%;font-size: 14px">
                                <el-button style="float: right;
                                margin-top: 14px;
                                background: #FF9901;border:1px solid #FF9901;
                                color:white;"
                                 size="small"
                                   @click.stop="upDataJurisdiction()" >
                                    详情
                                </el-button>
                                <div style="float: right;margin-top: 20px">
                                    终端辖区
                                    <el-switch
                                            :disabled="true"
                                            style="margin-right: 20px"
                                            v-model="terminal"
                                            active-color="#13ce66"
                                    >
                                    </el-switch>
                                </div>

                            </el-col>
                        </el-row>
                    </div>

                    <!--<div :class="$style.header">-->
                    <!--<span>文件夹</span>-->
                    <!--<span>{{companyName}}</span>-->

                    <!--</div>-->

                    <!--<div align="right">-->
                    <!--<el-button type="primary" icon="el-icon-edit">编辑</el-button>-->
                    <!--</div>-->


                    <div :class="$style.body">
                        <!--<router-view></router-view>-->
                        <!--<el-scrollbar :class="$style.scrollbar" >-->
                        <router-view></router-view>
                        <!--</el-scrollbar>-->
                    </div>
                </div>
            </el-main>
        </el-container>

        <!--新增辖区-->
        <el-dialog title="" :visible.sync="modeldialog" :show-close="false"
        id="add_jurisdictionManager">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
                <span style="color: #3998F7;font-size: 22px">新增辖区</span>
                <span>
                <el-button @click="saveJurisdiction()" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="modeldialog = false" size="small">取消</el-button>
                </span>
            </div>
            <el-form class="formSave" :model="addJurisdictionFrom" style="width: 80%;margin: auto" label-position="left">
                <el-form-item label="上级辖区" label-width="100px">
                    <el-row>
                        <el-col style="color: #3998f7;">
                            {{addJurisdictionFrom.topJurisdiction_name}}
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="辖区名称"  label-width="100px">
                    <el-input v-model="addJurisdictionFrom.jurisdiction_name" ></el-input>
                </el-form-item>
                <el-form-item label="辖区编码"  label-width="100px">
                    <el-input v-model="addJurisdictionFrom.jurisdiction_code" ></el-input>
                </el-form-item>
                <el-form-item label="辖区等级"  label-width="100px">
                    <el-select v-model="addJurisdictionFrom.jurisdiction_level" placeholder="" style="width: 100%" clearable>
                        <el-option v-for="(item,index) in jurisdictionLevel"
                                   :key="index"
                                   :label="item.value1"
                                   :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="说明" label-width="100px">
                    <el-input v-model="addJurisdictionFrom.commit" ></el-input>
                </el-form-item>
                <el-form-item label="终端辖区" label-width="100px">
                    <el-switch v-model="addJurisdictionFrom.terminalJurisdiction"
                               active-color="#13ce66"
                    >
                    </el-switch>
                </el-form-item>
                <el-form-item v-if="addJurisdictionFrom.terminalJurisdiction" label="所有人"
                              label-width="100px">
                    <el-cascader
                            style="width: 100%"
                            v-model="addJurisdictionFrom.selectPeople"
                            @change="changeEveryOne"
                            :show-all-levels="false"
                            :filterable="true"
                            :options="JurisdictionUser"
                            :props="cascader_props"
                            clearable></el-cascader>
<!--                    <el-select v-model="addJurisdictionFrom.selectPeople"-->
<!--                               style="width: 100%;"-->
<!--                               placeholder="请选择" @change="changeEveryOne">-->
<!--                        <el-option-->
<!--                                v-for="item,index in JurisdictionUser"-->
<!--                                :key="index"-->
<!--                                :label="item.alias"-->
<!--                                :value="item.user_id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                </el-form-item>
                <el-form-item v-if="addJurisdictionFrom.terminalJurisdiction" label="覆盖城市"
                              label-width="100px">
                    <el-cascader
                            style="width: 100%"
                            v-model="addJurisdictionFrom.city"
                            @change="changeEveryOne"
                            :options="city_array"
                            :filterable="true"
                            :props="city_props"
                            clearable></el-cascader>
                </el-form-item>
                <el-form-item v-if="addJurisdictionFrom.terminalJurisdiction" label="推广产品"
                              label-width="100px">
                    <el-select v-model="addJurisdictionFrom.product" value-key="product_id" multiple placeholder="请选择">
                        <el-option
                                v-for="item in productList"
                                :key="item"
                                :label="item.product_name"
                                :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!--编辑辖区-->
        <el-dialog title="" :visible.sync="upDatamodeldialog" :show-close="false"
                   id="update_jurisdictionManager">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
                <span style="color: #3998F7;font-size: 22px">辖区详情</span>
                <span>
<!--                <el-button @click="updataJurisdiction()" type="primary" size="small">保存</el-button>-->
                <el-button type="danger" @click="upDatamodeldialog = false" size="small">关闭</el-button>
                </span>
            </div>
            <el-form class="formSave" :model="upDataJurisdictionFrom" disabled style="width: 80%;margin: auto"
                     label-position="left">
                <!--                <el-form-item label="上级辖区" label-width="100px">-->
                <!--                    <el-row>-->
                <!--                        <el-col style="color: #3998f7;">-->
                <!--                            {{upDataJurisdictionFrom.topJurisdiction_name}}-->
                <!--                        </el-col>-->
                <!--                    </el-row>-->
                <!--                </el-form-item>-->
                <el-form-item label="辖区名称"  label-width="100px">
                    <el-input v-model="upDataJurisdictionFrom.jurisdiction_name" ></el-input>
                </el-form-item>
                <el-form-item label="辖区编码"  label-width="100px">
                    <el-input v-model="upDataJurisdictionFrom.jurisdiction_code" ></el-input>
                </el-form-item>
                <el-form-item label="辖区等级"  label-width="100px">
                    <el-select v-model="upDataJurisdictionFrom.jurisdiction_level" placeholder="" style="width: 100%" clearable>
                        <el-option v-for="(item,index) in jurisdictionLevel"
                                   :key="index"
                                   :label="item.value1"
                                   :value="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="说明" label-width="100px">
                    <el-input v-model="upDataJurisdictionFrom.commit" ></el-input>
                </el-form-item>
                <el-form-item label="终端辖区" label-width="100px">
                    <el-switch v-model="upDataJurisdictionFrom.terminalJurisdiction"
                               active-color="#13ce66"
                               >
                    </el-switch>
                </el-form-item>
                <el-form-item v-if="upDataJurisdictionFrom.terminalJurisdiction" label="所有人"
                              label-width="100px">

                    <el-cascader
                            style="width: 100%"
                            v-model="upDataJurisdictionFrom.selectPeople"
                            @change="changeEveryOne"
                            :show-all-levels="false"
                            :filterable="true"
                            :options="JurisdictionUser"
                            :props="cascader_props"
                            clearable></el-cascader>
<!--                    <el-select v-model="upDataJurisdictionFrom.selectPeople"  placeholder="请选择"-->
<!--                               @change="changeEveryOne" style="width: 100%;">-->
<!--                        <el-option-->
<!--                                v-for="item,index in JurisdictionUser"-->
<!--                                :key="index"-->
<!--                                :label="item.alias"-->
<!--                                :value="item.user_id">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                </el-form-item>
                <el-form-item v-if="upDataJurisdictionFrom.terminalJurisdiction" label="覆盖城市"
                              label-width="100px">
                    <el-cascader
                            style="width: 100%"
                            v-model="upDataJurisdictionFrom.city"
                            @change="changeEveryOne"
                            :options="city_array"
                            :filterable="true"
                            :props="city_props"
                            clearable></el-cascader>
                </el-form-item>
                <el-form-item v-if="upDataJurisdictionFrom.terminalJurisdiction" label="推广产品"
                              label-width="100px" class="selectProduct">
                    <el-select v-model="upDataJurisdictionFrom.product" value-key="product_id" multiple
                               placeholder="请选择" style="width: 100%">
                        <el-option
                                v-for="item in productList"
                                :key="item"
                                :label="item.product_name"
                                :value="item">
                        </el-option>
                    </el-select>

                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog :visible.sync="modelImport" :show-close="false" width="700px" style="margin-top: -70px">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
                <span style="color: #3998F7;font-size: 22px">数据导入与导出</span>
                <span>
                <el-button @click="" type="primary" size="small">保存</el-button>
                <el-button type="danger" @click="closeModal2" size="small">取消</el-button>
                </span>
            </div>
            <div style="padding: 20px 60px;">
                <!--                <el-row style="height: 30px">-->
                <!--                    <el-col :span="3" style="line-height:30px;font-weight: bold" >下载数据</el-col>-->
                <!--                    <el-col :span="3" style="line-height:30px">-->
                <!--                        <el-button type="primary" size="mini" @click="xiazai">-->
                <!--                            下载-->
                <!--                        </el-button>-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="12"style="padding-top: 8px">-->
                <!--                        辖区数据.xls-->
                <!--                    </el-col>-->
                <!--                </el-row>-->
                <!--                <el-row style="height: 30px;margin-top: 50px">-->
                <!--                    <el-col :span="3" style="line-height:30px;font-weight: bold" >辖区模板</el-col>-->
                <!--                    <el-col :span="3" style="line-height:30px">-->
                <!--                            <a style="text-decoration: none;color: #ffff;"-->
<!--                                               class="el-button el-button&#45;&#45;primary el-button&#45;&#45;mini"-->
                <!--                               href="../../../static/辖区模板.xlsx"-->
                <!--                               download="辖区模板.xlsx">下载</a>-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="10" style="padding-top: 8px">-->
                <!--                        辖区数据模版.xls-->
                <!--                    </el-col>-->
                <!--                </el-row>-->

                <!--                <el-row style="margin-top: 10px">-->
                <!--                    <el-col :span="5" style="line-height:30px;font-weight: bold;">-->
                <!--                        上传数据-->
                <!--                    </el-col>-->
                <!--                    <el-col :span="19" style="margin-top: 3px;margin-left: -45px ">-->
                <!--                        <el-upload-->
                <!--                                class="upload-demo"-->
                <!--                                ref="upload"-->
                <!--                                action="/wapi/v1/uploads"-->
                <!--                                :file-list="fileList"-->
                <!--                                :show-file-list="true"-->
                <!--                                :on-change="handleChange"-->
                <!--                                :on-success="handleSuccess"-->
                <!--                                :limit="1"-->
                <!--                                :auto-upload="false"-->
                <!--                        >-->
                <!--                            <el-button slot="trigger" size="small" style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件</el-button>-->
                <!--                            <el-button-->
                <!--                                    style="margin-left: 10px;"-->
                <!--                                    size="small"-->
                <!--                                    type="warning"-->
                <!--                                    @click="imortDataClick"-->
                <!--                            >导入数据</el-button>-->
                <!--                        </el-upload>-->
                <!--                    </el-col>-->
                <!--                </el-row>-->

                <el-row style="height: 30px">
                    <el-col :span="5" style="line-height:30px;font-weight: bold" >下载数据[医务]</el-col>
                    <el-col :span="3" style="line-height:30px">
                        <el-button type="primary" size="mini" @click="xiazai">
                            下载
                        </el-button>
                    </el-col>
                    <el-col :span="12"style="padding-top: 8px">
                        医疗机构-辖区数据(未生效).xls
                    </el-col>
                </el-row>
                <el-row style="height: 30px;margin-top: 10px">
                    <el-col :span="5" style="line-height:30px;font-weight: bold" >辖区模板[医务]</el-col>
                    <el-col :span="3" style="line-height:30px">
                            <a style="text-decoration: none;color: #ffff;"
                               class="el-button el-button--primary el-button--mini"
                               href="../../../static/医疗机构-辖区数据导入模板.xlsx"
                               download="医疗机构-辖区数据导入模板.xlsx">下载</a>
                    </el-col>
                    <el-col :span="10" style="padding-top: 8px">
                        医疗机构-辖区数据导入模板.xls
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="5"  style="line-height:30px;font-weight: bold">
                        上传数据[医务]
                    </el-col>
                    <el-col :span="16" style="margin-top: 3px;">
                        <el-upload
                                class="upload-demo"
                                ref="upload3"
                                action="/wapi/v1/uploads"
                                :file-list="fileList3"
                                :show-file-list="true"
                                :on-change="handleChange3"
                                :on-success="handleSuccess3"
                                :limit="1"
                                :auto-upload="false"
                        >
                            <el-button slot="trigger" size="small" style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件</el-button>
                            <el-button
                                    style="margin-left: 10px;"
                                    size="small"
                                    type="warning"
                                    @click="imortDataClick3"
                            >导入数据</el-button>
                        </el-upload>
                    </el-col>
                </el-row>

                <el-row style="height: 30px;margin-top: 30px">
                    <el-col :span="5" style="line-height:30px;font-weight: bold" >下载数据[零售]</el-col>
                    <el-col :span="3" style="line-height:30px">
                        <el-button type="primary" size="mini" @click="xiazai2">
                            下载
                        </el-button>
                    </el-col>
                    <el-col :span="12"style="padding-top: 8px">
                        零售数据-辖区数据(未生效).xls
                    </el-col>
                </el-row>
                <el-row style="height: 30px;margin-top: 10px">
                    <el-col :span="5" style="line-height:30px;font-weight: bold" >辖区模板[零售]</el-col>
                    <el-col :span="3" style="line-height:30px">
                            <a style="text-decoration: none;color: #ffff;"
                               class="el-button el-button--primary el-button--mini"
                               href="../../../static/零售终端-辖区数据导入模板.xlsx"
                               download="零售终端-辖区数据导入模板.xlsx">下载</a>
                    </el-col>
                    <el-col :span="10" style="padding-top: 8px">
                        零售终端-辖区数据导入模板.xls
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="5"  style="line-height:30px;font-weight: bold">
                        上传数据[零售]
                    </el-col>
                    <el-col :span="16" style="margin-top: 3px;">
                        <el-upload
                                class="upload-demo"
                                ref="upload2"
                                action="/wapi/v1/uploads"
                                :file-list="fileList2"
                                :show-file-list="true"
                                :on-change="handleChange2"
                                :on-success="handleSuccess2"
                                :limit="1"
                                :auto-upload="false"
                        >
                            <el-button slot="trigger" size="small" style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件</el-button>
                            <el-button
                                    style="margin-left: 10px;"
                                    size="small"
                                    type="warning"
                                    @click="imortDataClick2"
                            >导入数据</el-button>
                        </el-upload>
                    </el-col>
                </el-row>

                <el-row style="height: 30px;margin-top: 30px">
                    <el-col :span="5" style="line-height:30px;font-weight: bold" >下载数据[分销]</el-col>
                    <el-col :span="3" style="line-height:30px">
                        <el-button type="primary" size="mini" @click="xiazai3">
                            下载
                        </el-button>
                    </el-col>
                    <el-col :span="12"style="padding-top: 8px">
                        分销客户-辖区数据(未生效).xls
                    </el-col>
                </el-row>
                <el-row style="height: 30px;margin-top: 10px">
                    <el-col :span="5" style="line-height:30px;font-weight: bold" >辖区模板[分销]</el-col>
                    <el-col :span="3" style="line-height:30px">
                            <a style="text-decoration: none;color: #ffff;"
                               class="el-button el-button--primary el-button--mini"
                               href="../../../static/分销客户-辖区数据导入模板.xlsx"
                               download="分销客户-辖区数据导入模板.xlsx">下载</a>
                    </el-col>
                    <el-col :span="10" style="padding-top: 8px">
                        分销客户-辖区数据导入模板.xls
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px">
                    <el-col :span="5"  style="line-height:30px;font-weight: bold">
                        上传数据(分销)
                    </el-col>
                    <el-col :span="16" style="margin-top: 3px;">
                        <el-upload
                                class="upload-demo"
                                ref="upload4"
                                action="/wapi/v1/uploads"
                                :file-list="fileList4"
                                :show-file-list="true"
                                :on-change="handleChange4"
                                :on-success="handleSuccess4"
                                :limit="1"
                                :auto-upload="false"
                        >
                            <el-button slot="trigger" size="small" style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件</el-button>
                            <el-button
                                    style="margin-left: 10px;"
                                    size="small"
                                    type="warning"
                                    @click="imortDataClick4"
                            >导入数据</el-button>
                        </el-upload>
                    </el-col>
                </el-row>





                <!--<el-row style="height: 30px;margin-top: 20px">-->
                <!--<el-col :span="4" style="line-height:30px;font-weight: bold" >上传数据</el-col>-->

                <!--<el-col :span="20" style="margin-left: 10px;float: right">-->
                <!--<el-button type="success" size="small" style="margin: 0;height: 30px">选择文件</el-button>-->
                <!--<el-button type="warning" size="small" style="margin: 0;height: 30px">导入数据</el-button>-->
                <!--</el-col>-->
                <!--</el-row>-->

            </div>
        </el-dialog>
        <el-dialog :visible.sync="modeljurisdiction" :show-close="false" width="60%">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
                <span style="color: #3998F7;font-size: 22px">辖区数据生效</span>
                <span>
                <el-button type="danger" @click="modeljurisdiction = false" size="small">关闭</el-button>
                </span>
            </div>
            <div style="padding: 30px 60px;">
                <el-row style="text-align: center">
                <el-col :span="12">[本月] {{date}}
                    <el-button @click="effectNext('this')"
                            style="margin-left: 10px;background:#FF9901;border: 1px solid #FF9901;color: white; ">立即生效
                    </el-button></el-col>
                    <el-col :span="12">[下月] {{dateNext}}
                        <el-button @click="effectNext('next')"
                                   style="margin-left: 10px;background:#FF9901;border: 1px solid #FF9901;color: white ">立即生效
                        </el-button></el-col>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="modeljurisdictionExport" :show-close="false" width="60%">
            <div slot="title" class="dialog-footer"
                 style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:20px 0px">
                <span style="color: #3998F7;font-size: 22px">辖区数据导出</span>
                <span>
                <el-button type="danger" @click="modeljurisdictionExport = false" size="small">关闭</el-button>
                </span>
            </div>
            <div style="padding: 60px 60px;">
                <el-row >
                    <el-col > <span style="font-weight: bold">下载数据</span>
                        <el-date-picker
                                style="margin-left: 20px"
                                v-model="exportTime"
                                type="month"
                                placeholder="请选择月份">
                        </el-date-picker>
                        <el-button style="margin-left: 20px" type="primary" size="small">
                            下载
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="showModal2" :show-close="false"
                width="900px"
                style="margin-top: -20px"
        >
            <div slot="title">
                <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                    <span style="color: #3998F7;font-size: 22px">错误提示</span>
                    <span>
                        <el-button type="primary" size="small" @click="handleExportData">下载错误信息</el-button>
                    <el-button type="danger" size="small" @click="showModal2=false">关闭</el-button>
                </span>
                </div>
            </div>
            <el-table
                    border
                    :data="Mechanism"
                    stripe
                    height="450px"
                    style="width: 100%;margin-top: -20px"
                    header-cell-class-name="headerStyle"  :default-sort = "{prop: 'date', order: 'descending'}">
                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="75"></el-table-column>
                <el-table-column
                        prop="territory_code"
                        label="辖区编码"
                        min-width="120px"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="territory_name"
                        label="辖区名称"
                        min-width="150"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="channel"
                        label="渠道"
                        min-width="100%"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="institution_code"
                        label="机构编码"
                        min-width="120"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="institution_name"
                        label="机构名称"
                        min-width="150%"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="product_code"
                        label="产品编码"
                        min-width="120px"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="product_name"
                        label="产品名称"
                        min-width="100%"
                        sortable>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="报错信息"
                        width="240px">
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.message">
                            <span style="font-size: 10px;color: red">{{item}}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </el-dialog>

        <!--目标客户-->
        <el-dialog
                :visible.sync="showModal4" :show-close="false"
                width="900px"
                style="margin-top: -20px"
        >
            <div slot="title">
                <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                    <span style="color: #3998F7;font-size: 22px">错误提示</span>
                    <span>
                        <el-button type="primary" size="small" @click="handleExportData5">下载错误信息</el-button>
                    <el-button type="danger" size="small" @click="showModal4=false">关闭</el-button>
                </span>
                </div>
            </div>
            <el-table
                    border
                    :data="Mechanism3"
                    stripe
                    height="450px"
                    style="width: 100%;margin-top: -20px"
                    header-cell-class-name="headerStyle"  :default-sort = "{prop: 'date', order: 'descending'}">
                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="75"></el-table-column>
                <!--                <el-table-column-->
                <!--                        prop="yyyyMM"-->
                <!--                        label="年月"-->
                <!--                        min-width="120px"-->
                <!--                        sortable-->
                <!--                >-->
                <!--                </el-table-column>-->
                <el-table-column
                        prop="territory_code"
                        label="辖区编码"
                        min-width="120px"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="territory_name"
                        label="辖区名称"
                        min-width="120px"
                        sortable
                >
                </el-table-column>

                <!--<el-table-column-->
                <!--prop="user_code"-->
                <!--label="代表工号"-->
                <!--min-width="150"-->
                <!--sortable>-->
                <!--</el-table-column>-->
                <!--<el-table-column-->
                <!--prop="user_name"-->
                <!--label="代表姓名"-->
                <!--min-width="150"-->
                <!--sortable>-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="institution_code"
                        label="机构编码"
                        min-width="150"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="institution_name"
                        label="机构名称"
                        min-width="150"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="product_code"
                        label="产品编码"
                        min-width="150"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="product_name"
                        label="产品名称"
                        min-width="150"
                        sortable>
                </el-table-column>
                <!--                <el-table-column-->
                <!--                        prop="segment_id"-->
                <!--                        label="客户级别"-->
                <!--                        min-width="120px"-->
                <!--                        sortable>-->
                <!--                </el-table-column>-->

                <el-table-column
                        fixed="right"
                        label="报错信息"
                        width="240px">
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.message">
                            <span style="font-size: 10px;color: red">{{item}}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </el-dialog>

        <!--目标客户(门店)-->
        <el-dialog
                :visible.sync="showModal3" :show-close="false"
                width="900px"
                style="margin-top: -20px"
        >
            <div slot="title">
                <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                    <span style="color: #3998F7;font-size: 22px">错误提示</span>
                    <span>
                        <el-button type="primary" size="small" @click="handleExportData3">下载错误信息</el-button>
                    <el-button type="danger" size="small" @click="showModal3=false">关闭</el-button>
                </span>
                </div>
            </div>
            <el-table
                    border
                    :data="Mechanism2"
                    stripe
                    height="450px"
                    style="width: 100%;margin-top: -20px"
                    header-cell-class-name="headerStyle"  :default-sort = "{prop: 'date', order: 'descending'}">
                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="75"></el-table-column>
                <!--                <el-table-column-->
                <!--                        prop="yyyyMM"-->
                <!--                        label="年月"-->
                <!--                        min-width="120px"-->
                <!--                        sortable-->
                <!--                >-->
                <!--                </el-table-column>-->
                <el-table-column
                        prop="territory_code"
                        label="辖区编码"
                        min-width="120px"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="territory_name"
                        label="辖区名称"
                        min-width="120px"
                        sortable
                >
                </el-table-column>

                <!--<el-table-column-->
                <!--prop="user_code"-->
                <!--label="代表工号"-->
                <!--min-width="150"-->
                <!--sortable>-->
                <!--</el-table-column>-->
                <!--<el-table-column-->
                <!--prop="user_name"-->
                <!--label="代表姓名"-->
                <!--min-width="150"-->
                <!--sortable>-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="institution_code"
                        label="门店编码"
                        min-width="150"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="institution_name"
                        label="门店名称"
                        min-width="150"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="product_code"
                        label="产品编码"
                        min-width="120px"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="product_name"
                        label="产品名称"
                        min-width="120px"
                        sortable>
                </el-table-column>

                <el-table-column
                        fixed="right"
                        label="报错信息"
                        width="240px">
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.message">
                            <span style="font-size: 10px;color: red">{{item}}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </el-dialog>

        <!--目标客户(经销商)-->
        <el-dialog
                :visible.sync="showModal5" :show-close="false"
                width="900px"
                style="margin-top: -20px"
        >
            <div slot="title">
                <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                    <span style="color: #3998F7;font-size: 22px">错误提示</span>
                    <span>
                        <el-button type="primary" size="small" @click="handleExportData4">下载错误信息</el-button>
                    <el-button type="danger" size="small" @click="showModal5=false">关闭</el-button>
                </span>
                </div>
            </div>
            <el-table
                    border
                    :data="Mechanism4"
                    stripe
                    height="450px"
                    style="width: 100%;margin-top: -20px"
                    header-cell-class-name="headerStyle"  :default-sort = "{prop: 'date', order: 'descending'}">
                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="75"></el-table-column>
                <!--                <el-table-column-->
                <!--                        prop="yyyyMM"-->
                <!--                        label="年月"-->
                <!--                        min-width="120px"-->
                <!--                        sortable-->
                <!--                >-->
                <!--                </el-table-column>-->
                <el-table-column
                        prop="territory_code"
                        label="辖区编码"
                        min-width="120px"
                        sortable
                >
                </el-table-column>
                <el-table-column
                        prop="territory_name"
                        label="辖区名称"
                        min-width="120px"
                        sortable
                >
                </el-table-column>

                <!--<el-table-column-->
                <!--prop="user_code"-->
                <!--label="代表工号"-->
                <!--min-width="150"-->
                <!--sortable>-->
                <!--</el-table-column>-->
                <!--<el-table-column-->
                <!--prop="user_name"-->
                <!--label="代表姓名"-->
                <!--min-width="150"-->
                <!--sortable>-->
                <!--</el-table-column>-->
                <el-table-column
                        prop="institution_code"
                        label="经销商编码"
                        min-width="150"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="institution_name"
                        label="经销商姓名"
                        min-width="150"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="product_code"
                        label="产品编码"
                        min-width="120px"
                        sortable>
                </el-table-column>
                <el-table-column
                        prop="product_name"
                        label="产品名称"
                        min-width="120px"
                        sortable>
                </el-table-column>

                <el-table-column
                        fixed="right"
                        label="报错信息"
                        width="240px">
                    <template slot-scope="scope">
                        <div v-for="item in scope.row.message">
                            <span style="font-size: 10px;color: red">{{item}}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </el-dialog>
    </div>
</template>

<script>
    import http from '../../APIService/http'
    import jurisdiction from '../../assets/images/jurisdiction.png'
    import jurisdiction2 from '../../assets/images/jurisdiction2.png'
    import {bus} from '../../router/index.js'
    import { Message } from "element-ui";
    import moment from 'moment'
    import xlsx from "xlsx";
    export default {
        name: "home",
        data() {
            return {
                territoryArray:[],
                showModal3:false,
                showModal2:false,
                showModal4:false,
                showModal5:false,
                fileList:[],
                fileList2:[],
                fileList3:[],
                fileList4:[],
                nodekey:'',
                loading:false,
                exportTime:'',
                modeljurisdictionExport:false,
                modeljurisdiction:false,
                styleA: true,
                styleA2: false,
                onoffBj : false,
                modelImport:false,
                input:'',
                num: 1,
                dataTime:'',
                terminal: false,
                modeldialog: false,
                upDatamodeldialog:false,
                form:{
                    a:'',
                    b:'',
                    c:'',
                    d:'',
                    e:'',
                    status:false,
                    f:[{label:'1',value:'11'},{label:'2',value:'22'},{label:'3',value:'33'}],
                    g:[]
                },
                folderArry:[],
                level:0,
                defaultProps: {
                    label: 'territory_name',
                    children: 'children',
                    isLeaf: 'leaf'
                },
                icon:[jurisdiction,jurisdiction2],
                territory_name:'',
                territory_region:'',
                territory_code:'',
                owner_name:'',
                owner_title:'',
                nodeData : {},
                addJurisdictionFrom:{
                    topJurisdiction_name:'',
                    topJurisdiction_id:'',
                    jurisdiction_name:'',
                    jurisdiction_code:'',
                    jurisdiction_level:'',
                    commit:'',
                    terminalJurisdiction:false,
                    selectPeople:'',
                    city:[],
                    product:[]
                },
                productList:[],
                cascader_props:{
                    checkStrictly: true,
                    value : "ou_id",
                    label : "label",
                    disabled : "disabled",
                    emitPath:false
                },
                upDataJurisdictionFrom:{
                    topJurisdiction_name:'',
                    topJurisdiction_id:'',
                    jurisdiction_id:'',
                    jurisdiction_name:'',
                    jurisdiction_code:'',
                    jurisdiction_level:'',
                    commit:'',
                    terminalJurisdiction:false,
                    selectPeople:'',
                    month:'',
                    city:[],
                    product:[]
                },
                city_array:[],
                city_props:{
                    value : "id",
                    label : "label",
                    multiple: true
                },
                ismanager :this.$store.getters.getUser.role ==='staff' ? false : true,
                date:'',
                dateNext:'',
                jurisdictionLevel:[],
                JurisdictionUser:[],
                nodesave:'',
                resolvesave:'',
                saveOff:false,
                isCollapse:true,
                dateNextDate:'',
                dateThis:'',
                parentNodeKey:'',
                sonNodeKey:[],
                index:'',
                indexRemove:'',
                salList:'',
                Mechanism:[],
                arr:[],
                Territory:[],
                Mechanism3:[],
                arr3:[],
                isUpload: false,
                isUpload2: false,
                isUpload3: false,
                isUpload4: false,
                Mechanism2:[],
                arr2:[],
                Mechanism4:[],
                arr4:[],
                currentNode : null,
                currentNodeResolve : null,
                ter_id:'',
                isseach:false,
                search_data:{},
                onoffPrincipal:false,
                onoffManager:false,
                class_active:this.$store.getters.getUser.role ==='staff' ? false : true,
                infoObj:{}
            }
        },
        methods:{
            // recursion(){
            //     let _rLength = this.currentNode.childNodes
            //     console.log(_rLength)
            //     let _rNode = this.currentNode.childNodes[0]
            //     for (let i=0;i<_rLength.length;i++){
            //         if (_rLength[i].data.territory_id !== this.ter_id ){
            //             _rLength[i].checked = true
            //             _rLength[i].expanded = true
            //             _rLength[i].loadData();
            //             let that = this
            //             setTimeout(
            //                 that.recursion(),2000)
            //         }
            //     }
            // },
            //获取城市
            async getCity(){
                try {
                    let data= {}
                    data.tenant_id= this.$store.getters.getUser.tenant_id
                    await http.post('/wapi/JurActive/getCity',data).then(res=>{
                        // console.log(res)
                        if (res.success === true){
                            this.city_array = res.data
                        }
                    })
                }catch (e) {

                }
            },
            async getProductList(){
                try {
                    let data={}
                    data.tenant_id= this.$store.getters.getUser.tenant_id
                    data.user_id= this.$store.getters.getUser.user_id
                    await http.post('/wapi/JurActive/getProductList_home',data).then(res=>{
                        // console.log(res)
                        if (res.success === true){
                            this.productList = res.data
                        }
                    })
                }catch (e) {

                }
            },
           async handleSelect(item){
               try {
                   let user =this.$store.getters.getUser;
                   let obj={
                       tenant_id : user.tenant_id,
                       user_id : user.user_id,
                       territory_id  : item.territory_id
                   }
                   await http.post('/wapi/JurActive/selectJur',obj).then(res=>{
                       let data = res.data[0]
                       this.search_data = data
                       // console.log(data)
                       if (data.territory_type === 'CONTAINER'){

                           this.terminal = false
                           data.changesSalseList=[]
                           data.class_active = this.class_active
                           this.$store.commit('setDataInfo', data)
                           //console.log( this.$store.getters.getDataInfo)
                           if (this.$route.fullPath === '/Territorymanagement/index')
                           {
                               this.$router.push({path:'indexTow'})
                           }else {
                               this.$router.push({path:'index'})
                           }

                       } else {

                           this.terminal = true
                           data.changesSalseList=[]
                           data.class_active = this.class_active
                           this.$store.commit('setDataInfo', data)
                           if (this.$route.fullPath === '/Territorymanagement/institutions') {
                               this.$router.push({
                                   path:'institutionsTow',
                                   params:this.territoryArray
                               })
                           }else {
                               this.$router.push({
                                   path:'institutions',
                                   params:this.territoryArray
                               })
                           }

                       }
                       this.territory_name = data.territory_name
                       this.territory_level_name = data.territory_level_name
                       if (data.territory_type === 'CONTAINER'){
                           this.territory_region = '地区'
                       }else {
                           this.territory_region = '终端'
                       }
                       this.territory_code = data.territory_code
                       this.owner_name = data.owner_name
                       this.owner_title = data.title
                       this.salList = data.salseList.length
                       // console.log(this.salList)
                       this.isseach = true
                   })
               }catch (e) {

               }


                //
                // this.recursion()


            },
            async search (queryString, cb) {
                this.queryString = queryString.trim()
                if (queryString) {
                    try {
                        var user = this.$store.getters.getUser
                        let data ={
                            user_id :user.user_id,
                            tenant_id: user.tenant_id,
                            search: this.queryString,
                            month : moment().format('YYYYMM'),
                            type : true,
                            isAdmin:false
                        }
                        if (this.class_active){
                            data.type = true
                        } else {
                            data.type = false
                        }
                        if (user.role === 'admin'){
                            data.isAdmin=true
                        }

                        await http.post('/wapi/territory_router/searchJur',data).then(res=>{
                            if(res.success){
                                // console.log(res)
                                cb(res.data)
                            }
                        })
                    } catch (err) {
                        this.error()
                    }
                } else {
                    cb([])
                    this.$refs.tree.filter();

                }
            },
            handleChange4 (file, fileList) {

                this.file = file.name
                const nameArr = file.name.split('.')
                const extension = nameArr[nameArr.length-1] === 'xlsx'
                const isLt2M = file.size / 1024 / 1024 < 10
                if (!extension) {
                    this.file = ''
                    this.fileList4 = []
                    Message({
                        showClose: true,
                        message: '上传模板只能是xlsx',
                        type: 'error'
                    })
                }
                if (!isLt2M) {
                    this.file = ''
                    this.fileList4 = []
                    Message({
                        showClose: true,
                        message: '传模板大小不能超过 10MB',
                        type: 'error'
                    })
                }
                this.isUpload4 = true

                return extension && isLt2M
            },
            async handleSuccess4(res, file) {
                // console.log(res)

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (res.success) {
                    try {
//                        var user = this.$store.getters.getUser

                        let data = {
                            user_id: this.$store.getters.getUser.user_id,
                            tenant_id: this.$store.getters.getUser.tenant_id,
                            path: res.data,
                        }

                        await http.post('/wapi/excel/imortTerritoryDistributor',data).then(res => {
                            loading.close()
                            if (res.success) {
                                this.closeModal2()
                                if(res.data.length==0){
                                    Message({
                                        type: 'success',
                                        message: '导入成功'
                                    })
                                }else {
                                    this.showModal5 = true
                                    this.Mechanism4=[...res.data]
                                    this.arr4=[...res.data]
                                    Message({
                                        type: 'success',
                                        message: '导入成功'
                                    })
                                }

                            } else {
                                this.fileList4 = []

                                Message({
                                    type: 'error',
                                    message: '导入失败'
                                })
                            }

                            this.loading = false
                        })
                    }catch (err) {
                        loading.close()
                        Message.error('导入失败！')
                    }
                } else {
                    loading.close()
                    Message.error('导入失败！')
                }
            },
            handleChange2 (file, fileList) {

                this.file = file.name
                const nameArr = file.name.split('.')
                const extension = nameArr[nameArr.length-1] === 'xlsx'
                const isLt2M = file.size / 1024 / 1024 < 10
                if (!extension) {
                    this.file = ''
                    this.fileList2 = []
                    Message({
                        showClose: true,
                        message: '上传模板只能是xlsx',
                        type: 'error'
                    })
                }
                if (!isLt2M) {
                    this.file = ''
                    this.fileList2 = []
                    Message({
                        showClose: true,
                        message: '传模板大小不能超过 10MB',
                        type: 'error'
                    })
                }
                this.isUpload2 = true

                return extension && isLt2M
            },
            async handleSuccess2(res, file) {
                // console.log(res)

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (res.success) {
                    try {
//                        var user = this.$store.getters.getUser

                        let data = {
                            user_id: this.$store.getters.getUser.user_id,
                            tenant_id: this.$store.getters.getUser.tenant_id,
                            path: res.data,
                        }

                        await http.post('/wapi/excel/imortTerritoryRetailStore',data).then(res => {
                            loading.close()
                            if (res.success) {
                                this.closeModal2()
                                if(res.data.length==0){
                                    Message({
                                        type: 'success',
                                        message: '导入成功'
                                    })
                                }else {
                                    this.showModal3 = true
                                    this.Mechanism2=[...res.data]
                                    this.arr2=[...res.data]
                                    Message({
                                        type: 'success',
                                        message: '导入成功'
                                    })
                                }

                            } else {
                                this.fileList2 = []
                                Message({
                                    type: 'error',
                                    message: '导入失败'
                                })
                            }

                            this.loading = false
                        })
                    }catch (err) {
                        loading.close()
                        Message.error('导入失败！')
                    }
                } else {
                    loading.close()
                    Message.error('导入失败！')
                }
            },

            handleChange3 (file, fileList) {

                this.file = file.name
                const nameArr = file.name.split('.')
                const extension = nameArr[nameArr.length-1] === 'xlsx'
                const isLt2M = file.size / 1024 / 1024 < 10
                if (!extension) {
                    this.file = ''
                    this.fileList3 = []
                    Message({
                        showClose: true,
                        message: '上传模板只能是xlsx',
                        type: 'error'
                    })
                }
                if (!isLt2M) {
                    this.file = ''
                    this.fileList3 = []
                    Message({
                        showClose: true,
                        message: '传模板大小不能超过 10MB',
                        type: 'error'
                    })
                }
                this.isUpload3 = true

                return extension && isLt2M
            },
            async handleSuccess3(res, file) {
                // console.log(res)

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (res.success) {
                    try {
//                        var user = this.$store.getters.getUser

                        let data = {
                            user_id: this.$store.getters.getUser.user_id,
                            tenant_id: this.$store.getters.getUser.tenant_id,
                            path: res.data,
                        }

                        await http.post('/wapi/excel/imortTerritoryHcp', data).then(res => {
                            loading.close()
                            if (res.success) {
                                this.closeModal2()
                                if(res.data.length==0){
                                    Message({
                                        type: 'success',
                                        message: '导入成功'
                                    })
                                }else {
                                    this.showModal4 = true
                                    this.Mechanism3=[...res.data]
                                    this.arr3=[...res.data]
                                    // console.log(this.Mechanism3)
                                    Message({
                                        type: 'success',
                                        message: '导入成功'
                                    })
                                }

                            } else {
                                this.fileList3 = []

                                Message({
                                    type: 'error',
                                    message: '导入失败'
                                })
                            }

                            this.loading = false
                        })
                    }catch (err) {
                        loading.close()
                        Message.error('导入失败！')
                    }
                } else {
                    loading.close()
                    Message.error('导入失败！')
                }
            },
            imortDataClick3 () {
                if (this.isUpload3) {
                    this.$refs.upload3.submit()
                } else {
                    Message({
                        showClose: true,
                        message: '导入模板不能为空',
                        type: 'error'
                    })
                }
            },

            imortDataClick2 () {
                if (this.isUpload2) {
                    this.$refs.upload2.submit()
                } else {
                    Message({
                        showClose: true,
                        message: '导入模板不能为空',
                        type: 'error'
                    })
                }
            },
            imortDataClick4 () {
                if (this.isUpload4) {
                    this.$refs.upload4.submit()
                } else {
                    Message({
                        showClose: true,
                        message: '导入模板不能为空',
                        type: 'error'
                    })
                }
            },
            xiazai(){

                this.deriveTerritory()
            },
            xiazai2(){

                this.deriveTerritoryRetailStore()
            },
            xiazai3(){

                this.deriveTerritoryDistributor()
            },
            async deriveTerritory(){

                let data = {
                    tenant_id:this.$store.getters.getUser.tenant_id
                }
                let self = this
//                this.Territory=[]
                await http.post('/wapi/derive/deriveTerritoryHcp',data).then(res => {

                    self.Territory=res
                    this.handleExportData2()
                    // console.log(self.Territory)
                }).catch((err)=>{
                    Message({
                        type: 'error',
                        message: '下载失败'
                    })
                })

            },
            async deriveTerritoryRetailStore(){

                let data = {
                    tenant_id:this.$store.getters.getUser.tenant_id
                }
                let self = this
//                this.Territory=[]
                await http.post('/wapi/derive/deriveTerritoryRetailStore',data).then(res => {

                    self.Territory2=res
                    this.handleExportData6()
                    // console.log(self.Territory)
                }).catch((err)=>{
                    Message({
                        type: 'error',
                        message: '下载失败'
                    })
                })

            },
            async deriveTerritoryDistributor(){

                let data = {
                    tenant_id:this.$store.getters.getUser.tenant_id
                }
                let self = this
//                this.Territory=[]
                await http.post('/wapi/derive/deriveTerritoryDistributor',data).then(res => {

                    self.Territory3=res
                    this.handleExportData7()
                    // console.log(self.Territory)
                }).catch((err)=>{
                    Message({
                        type: 'error',
                        message: '下载失败'
                    })
                })

            },

            handleChange (file, fileList) {

                this.file = file.name
                const nameArr = file.name.split('.')
                const extension = nameArr[nameArr.length-1] === 'xlsx'
                const isLt2M = file.size / 1024 / 1024 < 10
                if (!extension) {
                    this.file = ''
                    this.fileList = []
                    Message({
                        showClose: true,
                        message: '上传模板只能是xlsx',
                        type: 'error'
                    })
                }
                if (!isLt2M) {
                    this.file = ''
                    this.fileList = []
                    Message({
                        showClose: true,
                        message: '传模板大小不能超过 10MB',
                        type: 'error'
                    })
                }
                this.isUpload = true

                return extension && isLt2M
            },
            async handleSuccess(res, file) {
                // console.log(res)

                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                if (res.success) {
                    try {
//                        var user = this.$store.getters.getUser

                        let data = {
                            user_id: this.$store.getters.getUser.user_id,
                            tenant_id: this.$store.getters.getUser.tenant_id,
                            path: res.data,
                        }

                        await http.post('/wapi/excel/imortTerritory', data).then(res => {
                            loading.close()
                            if (res.success) {
                                this.closeModal2()

                                if(res.data.length==0){
                                    Message({
                                        type: 'success',
                                        message: '导入成功'
                                    })
                                }else {
                                    this.showModal2 = true
                                    this.Mechanism=[...res.data]
                                    this.arr=[...res.data]

                                }

                            } else {
                                this.fileList = []

                                Message({
                                    type: 'error',
                                    message: '导入失败'
                                })
                            }

                            this.loading = false
                        })
                    }catch (err) {
                        loading.close()
                        Message.error('导入失败！')
                    }
                } else {
                    loading.close()
                    Message.error('导入失败！')
                }
            },
            imortDataClick () {
                if (this.isUpload) {
                    this.$refs.upload.submit()
                } else {
                    Message({
                        showClose: true,
                        message: '导入模板不能为空',
                        type: 'error'
                    })
                }
            },
            closeModal2(){
                this.fileList = []
                this.fileList3 = []
                this.fileList2 = []
                this.fileList4 = []
                this.modelImport = false
                this.isUpload = false
                this.isUpload3 = false
                this.isUpload4 = false
                this.isUpload2 = false
            },

            handleExportData(){
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['辖区编码', '辖区名称', '渠道', '机构编码', '机构名称', '产品编码', '产品名称','报错信息']
                        const filterVal = [
                            'territory_code',
                            'territory_name',
                            'channel',
                            'institution_code',
                            'institution_name',
                            'product_code',
                            'product_name',
                            'message'
                        ]
                        let arr=[...this.arr]
                        for (var i = 0; i < arr.length; i++) {
                            let obj = arr[i].message.join(" ")
                            arr[i].message = obj
                        }

                        const list = arr
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '报错信息表',
                            autoWidth: this.autoWidth
                        })
                    })
                    this.loading = false
                    this.showModal2=false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            handleExportData2(){
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['辖区编码', '辖区名称','机构编码', '机构名称', '产品编码', '产品名称']
                        const filterVal = [
                            'territory_code',
                            'territory_name',
                            'institution_code',
                            'institution_name',
                            'product_code',
                            'product_name',
                        ]


                        const list = this.Territory
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '辖区数据[医务]',
                            autoWidth: this.autoWidth
                        })
                    })
                    this.loading = false
                    // this.showModal2=false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            handleExportData3(){
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['辖区编码','辖区名称', '门店编码', '门店名称', '产品编码','产品名称','报错信息']
                        const filterVal = [
                            'territory_code',
                            'territory_name',
                            'institution_code',
                            'institution_name',
                            'product_code',
                            'product_name',
                            'message'
                        ]
                        let arr=[...this.arr2]
                        for (var i = 0; i < arr.length; i++) {
                            let obj = arr[i].message.join(" ")
                            arr[i].message = obj
                        }

                        const list = arr
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '报错信息表',
                            autoWidth: this.autoWidth
                        })
                    })
                    this.loading = false
                    this.showModal3=false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            handleExportData4(){
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['辖区编码','辖区名称', '经销商编码', '经销商名称', '产品编码','产品名称','报错信息']
                        const filterVal = [

                            'territory_code',
                            'territory_name',
                            'institution_code',
                            'institution_name',
                            'product_code',
                            'product_name',
                            'message'
                        ]
                        let arr=[...this.arr4]
                        for (var i = 0; i < arr.length; i++) {
                            let obj = arr[i].message.join(" ")
                            arr[i].message = obj
                        }

                        const list = arr
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '报错信息表',
                            autoWidth: this.autoWidth
                        })
                    })
                    this.loading = false
                    this.showModal5=false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            handleExportData5(){
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['辖区编码','辖区名称', '机构编码', '机构名称', '产品编码','产品名称','报错信息']
                        const filterVal = [
                            'territory_code',
                            'territory_name',
                            'institution_code',
                            'institution_name',
                            'product_code',
                            'product_name',
                            'message'
                        ]
                        let arr=[...this.arr3]
                        for (var i = 0; i < arr.length; i++) {
                            let obj = arr[i].message.join(" ")
                            arr[i].message = obj
                        }

                        const list = arr
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '报错信息表',
                            autoWidth: this.autoWidth
                        })
                    })
                    this.loading = false
                    this.showModal4=false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            handleExportData6(){
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['辖区编码', '辖区名称','门店编码', '门店名称', '产品编码', '产品名称']
                        const filterVal = [
                            'territory_code',
                            'territory_name',
                            'store_code',
                            'store_name',
                            'product_code',
                            'product_name',
                        ]


                        const list = this.Territory2
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '辖区数据[零售]',
                            autoWidth: this.autoWidth
                        })
                    })
                    this.loading = false
                    // this.showModal2=false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            handleExportData7(){
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['辖区编码', '辖区名称','经销商编码', '经销名称', '产品编码', '产品名称']
                        const filterVal = [
                            'territory_code',
                            'territory_name',
                            'distributor_code',
                            'distributor_name',
                            'product_code',
                            'product_name',
                        ]


                        const list = this.Territory3
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '辖区数据[分销]',
                            autoWidth: this.autoWidth
                        })
                    })
                    this.loading = false
                    // this.showModal2=false
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            handleNodeClick(data,node,ele){
                this.isseach = false
                this.parentNodeKey = node.parent.data.territory_id
                this.sonNodeKey = node.data.territory_id
                // console.log(data,node,333)
                this.getTerritoryInfo(data,node)

                //  this.styleA = true
                //  this.styleA2 = false
                //  this.level = item2.level
                // if (item2.level === 2 || item2.level === 1){
                //     this.$router.push('/jurisdiction/index')
                // }else if (item2.level === 3){
                //     this.$router.push('/jurisdiction/institutions')
                // }
            },
            async getTerritoryInfo(territoryObj,node){
                try{
                    this.loading = true
                    let data ={}
                    data.month = new Date()
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.territory_id = territoryObj.territory_id
                    data.territory_type = territoryObj.territory_type
                    await http.post('/wapi/territory_router/getMoreTerritoryInfo',data).then(res=>{
                        // let obj = res
                        // let info = Object.assign(obj,territoryObj)
                        //    info.changesSalseList=[]
                        //     this.$store.commit('setDataInfo', info)

                        this.infoObj = res.data
                        // console.log(this.infoObj,333)
                        this.nodeData = node
                        this.nodeData.data = Object.assign(node.data,res.data)
                        this.loading = false
                        this.$nextTick().then(()=>{
                            let  data = Object.assign(this.infoObj,territoryObj)
                            this.nodeData = node
                            data.class_active = this.class_active
                            if (data.territory_type === 'CONTAINER'){
                                this.saveOff = false
                                this.terminal = false
                                data.changesSalseList=[]
                                this.$store.commit('setDataInfo', data)
                                //console.log( this.$store.getters.getDataInfo)
                                if (this.$route.fullPath === '/Territorymanagement/index')
                                {
                                    this.$router.push({path:'indexTow'})
                                }else {
                                    this.$router.push({path:'index'})
                                }

                            } else {
                                this.saveOff = true
                                this.terminal = true
                                data.changesSalseList=[]
                                this.$store.commit('setDataInfo', data)
                                if (this.$route.fullPath === '/Territorymanagement/institutions') {
                                    this.$router.push({
                                        path:'institutionsTow',
                                        params:this.territoryArray
                                    })
                                }else {
                                    this.$router.push({
                                        path:'institutions',
                                        params:this.territoryArray
                                    })
                                }

                            }
                            this.territory_name = data.territory_name
                            this.territory_level_name = data.territory_level_name
                            if (data.territory_type === 'CONTAINER'){
                                this.territory_region = '地区'
                            }else {
                                this.territory_region = '终端'
                            }
                            this.territory_code = data.territory_code
                            this.owner_name = data.owner_name
                            this.owner_title = data.title
                            this.salList = data.salseList.length
                            // console.log(this.salList)
                        })
                    })
                }catch (e) {

                }
            },
            importExport(){
                this.modelImport = true
            },
            changeEveryOne(item){
                // console.log(item)
                // console.log(this.form)
            },
            effectNo(){
                this.onoffBj = true
                // this.styleA = true
                // this.styleA2 = false
                this.$router.push('/Territorymanagement/index')
                // if (this.level === 2){
                //     this.$router.push('/jurisdiction/index')
                // } else {
                //     this.$router.push('/jurisdiction/institutions')
                // }
            },
            effectOff(){
                this.onoffBj = false
                // this.styleA = false
                // this.styleA2 = true
                this.$router.push('/Territorymanagement/indexActive')
                // if (this.$route.fullPath === '/jurisdiction/index')
                // {
                //     this.$router.push({path:'index2Tow'})
                // }else {
                //     this.$router.push({path:'index2'})
                // }
                // if (this.level === 2){
                //     this.$router.push('/jurisdiction/index2')
                // } else {
                //     this.$router.push('/jurisdiction/institutions2')
                // }
            },
            handleNodeExpand(a,b,c){
                // console.log(a)
                // console.log(b)
                // console.log(c)
            },
            loadNode(node,resolve){
                this.currentNodeResolve = resolve
                this.currentNode = node
                this.getLoadNode(node,resolve)
            },
            async getLoadNode(node,resolve){

                let data={
                    tenant_id : this.$store.getters.getUser.tenant_id,
                    user_id : this.$store.getters.getUser.user_id,
                    month : new Date(),
                    territory_id : node.data.territory_id
                }

                if (node.level > 0){

                    await http.post('/wapi/JurActive/jurisdiction',data).then(res=>{

                        for (let i=0;i<res.length;i++){
                            if (res[i].territory_type === 'ENDPOINT' || res[i].isThereData === 0){
                                res[i].leaf = true
                            }
                        }
                        resolve(res)
                        for (let i=0;i<res.length;i++){
                            if (this.nodeData.data.territory_id === res[i].territory_id){
                                this.nodeData.data = res[i]
                                this.territory_name = this.nodeData.data.territory_name
                            }
                        }
                    })
                }

            },
            refreshNodeBy(id){
                if (id){
                    let node = this.$refs.menusTreeJur.getNode(id); // 通过节点id找到对应树节点对象

                    if (node){
                        node.loaded = false;
                        node.expand();// 主动调用展开节点方法，重新查询该节点下的所有子节点
                    }

                } else {
                    this.init()
                }

            },
            addJurisdiction(){
                this.modeldialog = true
                this.addJurisdictionFrom.topJurisdiction_name = this.nodeData.data.territory_name
                this.addJurisdictionFrom.topJurisdiction_id = this.nodeData.data.territory_id
                this.modeldialog = true
            },
            upDataJurisdiction(){
                if (this.isseach === true) {

                    this.upDataJurisdictionFrom.topJurisdiction_id = ''
                    this.upDataJurisdictionFrom.jurisdiction_id = this.search_data.territory_id
                    this.upDataJurisdictionFrom.jurisdiction_name = this.search_data.territory_name
                    this.upDataJurisdictionFrom.jurisdiction_code = this.search_data.territory_code
                    this.upDataJurisdictionFrom.jurisdiction_level = this.search_data.territory_level_name
                    this.upDataJurisdictionFrom.month = this.search_data.month
                    this.upDataJurisdictionFrom.commit = this.search_data.comments
                    this.upDataJurisdictionFrom.city = []
                    if (this.search_data.cityList.length >0){
                        for (let i =0;i<this.search_data.cityList.length;i++) {
                            let arr=[]
                            let p_id = this.search_data.cityList[i].province_id
                            let c_id = this.search_data.cityList[i].city_id
                            arr.push(p_id)
                            arr.push(c_id)
                            this.upDataJurisdictionFrom.city.push(arr)
                        }
                    }
                    this.upDataJurisdictionFrom.product = []
                    this.upDataJurisdictionFrom.product = this.search_data.productTerriTory
                    if (this.search_data.territory_type === 'CONTAINER') {
                        this.upDataJurisdictionFrom.terminalJurisdiction = false
                    }else {
                        this.upDataJurisdictionFrom.terminalJurisdiction = true
                    }
                    this.upDataJurisdictionFrom.selectPeople = this.search_data.owner_id
                }else {
                    this.upDataJurisdictionFrom.topJurisdiction_id = this.nodeData.parent.data.territory_id
                    this.upDataJurisdictionFrom.jurisdiction_id = this.nodeData.data.territory_id
                    this.upDataJurisdictionFrom.jurisdiction_name = this.nodeData.data.territory_name
                    this.upDataJurisdictionFrom.jurisdiction_code = this.nodeData.data.territory_code
                    this.upDataJurisdictionFrom.jurisdiction_level = this.nodeData.data.territory_level_name
                    this.upDataJurisdictionFrom.month = this.nodeData.data.month
                    this.upDataJurisdictionFrom.commit = this.nodeData.data.comments
                    this.upDataJurisdictionFrom.city = []
                    if (this.nodeData.data.cityList.length >0){
                        for (let i =0;i<this.nodeData.data.cityList.length;i++) {
                            let arr=[]
                            let p_id = this.nodeData.data.cityList[i].province_id
                            let c_id = this.nodeData.data.cityList[i].city_id
                            arr.push(p_id)
                            arr.push(c_id)
                            this.upDataJurisdictionFrom.city.push(arr)
                        }
                    }
                    this.upDataJurisdictionFrom.product = []
                    this.upDataJurisdictionFrom.product = this.nodeData.data.productTerriTory
                    if (this.nodeData.data.territory_type === 'CONTAINER') {
                        this.upDataJurisdictionFrom.terminalJurisdiction = false
                    }else {
                        this.upDataJurisdictionFrom.terminalJurisdiction = true
                    }
                    this.upDataJurisdictionFrom.selectPeople = this.nodeData.data.owner_id
                }

                this.upDatamodeldialog = true

            },
            jurisdictionEffect(){
                let date = new Date()
                let dateY = date.Format('yyyy')
                let dateT = date.Format('MM')
                this.date = dateY+'年'+dateT+'月数据'
                if (parseInt(dateT) == 12){

                    dateY = parseInt(dateY)+1
                    dateT = 0
                }
                this.dateNext = dateY+'年'+(parseInt(dateT)+1) +'月数据'
                this.dateNextDate = parseInt(date.Format('yyyyMM'))+1
                this.dateThis = date.Format('yyyyMM')
                this.modeljurisdiction = true
            },
            async saveJurisdiction(){
                let data = this.addJurisdictionFrom
                data.tenant_id = this.$store.getters.getUser.tenant_id
                data.user_id = this.$store.getters.getUser.user_id
                data.month = new Date()

                if (data.jurisdiction_name == '') {
                    this.$message({
                        type: 'error',
                        message: '请将信息填写完全'
                    })
                }else {
                    try {
                        await http.post('/wapi/JurActive/saveJurisdiction',data).then(res=>{
                            if (res.success === true){
                                if (data.topJurisdiction_id) {
                                    this.refreshNodeBy(data.topJurisdiction_id)
                                }else {
                                    this.init()
                                }
                                for (let key in this.addJurisdictionFrom) {
                                    this.addJurisdictionFrom[key]=''
                                }
                                this.addJurisdictionFrom.terminalJurisdiction = false
                                this.addJurisdictionFrom.city = []
                            }
                        })
                    }catch (e) {

                    }
                    this.modeldialog = false
                }

            },
            async updataJurisdiction(){
                let data = this.upDataJurisdictionFrom
                data.tenant_id = this.$store.getters.getUser.tenant_id
                if (data.jurisdiction_name == '') {
                    this.$message({
                        type: 'error',
                        message: '请填写辖区名字'
                    })
                }else {
                    try {
                        await http.post('/wapi/JurActive/updataJurisdiction', data).then(res => {
                            if (res.success === true) {
                                if (data.topJurisdiction_id) {
                                    this.refreshNodeBy(data.topJurisdiction_id)
                                }else {
                                    this.init()
                                }

                                this.$message({
                                    type: 'success',
                                    message: '更新成功'
                                })
                                this.index = new Date()
                            }

                        })
                        this.upDatamodeldialog = false
                    } catch (e) {

                    }
                }
            },
            async init(type){
                try {
                    if (type === 'principal'){
                        this.class_active = false
                    } else if (type === "management") {
                        this.class_active = true
                    }
                    this.loading = true
                    let user = this.$store.getters.getUser
                    if (user.role === 'staff'){
                        this.onoffManager = false
                        this.onoffPrincipal = false
                    } else {
                        this.onoffManager = true
                        this.onoffPrincipal = true
                    }



                    let data={}
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.month = new Date()
                    if (user.role === 'staff') {
                        data.type = "staff"
                    }else if (user.role === 'manager') {
                        data.type = "MANAGE"
                        data.class_active = this.class_active

                    }else {
                        data.type = "admin"
                        data.class_active = this.class_active
                    }
                    await http.post('/wapi/territory_router/getTerritoryList',data).then(res=>{
                        this.territoryArray = res.data.array[0]
                        let array = res.data.array
                        if (res.data.obj.length === 0 ){
                            this.onoffPrincipal = false
                            this.onoffManager = false
                            this.$store.commit('setDataInfo', {})
                        }else {
                            this.onoffPrincipal = true
                            this.onoffManager = true
                        }

                        // if (user.role === 'admin') {
                        //     this.onoffManager = false
                        //     this.onoffPrincipal = false
                        // }
                        if (user.role === 'staff') {
                            this.onoffManager = false
                            this.onoffPrincipal = false
                        }

                        // array.forEach(item=>{
                        //     item.children= []
                        //     for (let i=0;i<item.productArray.length;i++){
                        //         item.children.push({territory_name:item.productArray[i]})
                        //     }
                        //
                        // })
                        this.folderArry = array
                        for (let i =0;i<this.folderArry.length;i++){
                            if (this.folderArry[i].territory_type === 'ENDPOINT') {
                                this.folderArry[i].leaf = true
                            }
                        }
                        //  this.handleNodeClick(this.folderArry[0],this.folderArry[0])
                        //    this.$nextTick(() => {
                        //        this.sonNodeKey.push(this.folderArry[0].territory_id)
                        //        console.log(1)
                        //        this.$refs.menusTree.setCheckedKeys(this.folderArry[0].territory_id);//获取已经设置的资源后渲染
                        //    });
                        this.$nextTick().then(() =>{
                            const firstNode = document.querySelector('.el-tree-node')
                            firstNode.click();
                        })
                        this.loading = false
                    })
                }catch (e) {

                }
            },
            clickTab(item){
                if (item === 'inactive'){
                    this.$router.push('/Territorymanagement/index')
                } else if (item === 'active'){
                    this.$router.push('/Territorymanagement/indexActive')
                }
            },
            async getJurisdictionLevel(){
                try {
                    let data= {}
                    data.tenant_id= this.$store.getters.getUser.tenant_id
                    await http.post('/wapi/JurActive/getJurisdictionLevel',data).then(res=>{
                        if (res.success === true){
                            this.jurisdictionLevel = res.data
                        }
                    })
                }catch (e) {

                }
            },
            async getJurisdictionUser(){
                try {
                    let data= {}
                    data.tenant_id= this.$store.getters.getUser.tenant_id
                    await http.post('/wapi/JurActive/getJurisdictionUser',data).then(res=>{
                        if (res.success === true){
                            this.JurisdictionUser = res.data
                        }
                    })
                }catch (e) {

                }
            },
            async effectThis(){
                this.modeljurisdiction = false
            },
            async effectNext(str){
                try {

                    let data={}
                    data.tenant_id = this.$store.getters.getUser.tenant_id
                    data.user_id = this.$store.getters.getUser.user_id
                    data.next = str
                    if (str === 'next'){
                        data.month = parseInt(new Date().Format('yyyyMM'))+1
                    }else {
                        data.month =new Date().Format('yyyy-MM')
                    }

                    await http.post('/wapi/JurActive/jurisdictionEffectNext',data).then(res=>{
                        if (res.success == true){
                            this.modeljurisdiction = false
                            this.$message({
                                type: 'success',
                                message: '辖区生效成功'
                            })
                        }
                    })
                }catch (e) {

                }
            }
        },
        created() {
            this.init()
            this.getJurisdictionLevel()
            this.getJurisdictionUser()
            this.getCity()
        },
        mounted(){
            if (this.$route.fullPath.indexOf('Active') == -1){
                this.styleA = true
                this.styleA2 = false
            }
            this.getProductList()
        },
        updated() {
            console.log(this.onoffManager)
            console.log(this.onoffPrincipal)
        },
        beforeDestroy() {
            let obj = this.$store.getters.getDataInfo
            for(let key in obj){
                obj[key]  = ''
            }
        },
        computed: {
            listenStore() {
                return this.$store.getters.getDataInfo;
            },
            //刷新页面树形数据
            changeTree(){
                let index = ''
                bus.$on('changeList',(e)=>{
                    this.index = e
                })
                return this.index
            },
            changeTreeRemove(){
                let index = ''
                bus.$on('changeTreeList',(e)=>{
                    this.indexRemove = e
                })
                return this.indexRemove
            }
        },
        watch:{
            // listenStore:{
            //     handler:function (val,oldVal) {
            //
            //         this.refreshNodeBy(this.parentNodeKey)
            //     },
            //     deep:true
            //
            // },
            changeTree:function (val,oldval) {
                this.refreshNodeBy(this.parentNodeKey)
                this.loading = true
                let store = this.$refs.menusTreeJur.store;
                let that = this
                setTimeout(e=>{

                    // const node = store.getNode(this.sonNodeKey);
                    for (let i in store.nodesMap){
                        if (that.sonNodeKey == i){


                            let getDataInfo = store.nodesMap[i].data
                            let obj = this.$store.getters.getDataInfo
                            for (let item in getDataInfo){
                                obj[item] = getDataInfo[item]
                            }
                            this.$store.commit('setDataInfo', getDataInfo)
                            let data =this.$store.getters.getDataInfo
                            this.territory_name = data.territory_name
                            this.territory_level_name = data.territory_level_name

                            if (data.territory_type === 'CONTAINER'){
                                this.territory_region = '地区'
                            }else {
                                this.territory_region = '终端'
                            }
                            this.territory_code = data.territory_code
                            this.owner_name = data.owner_name
                            this.owner_title = data.title
                            this.salList = data.salseList.length

                            // if (this.$route.fullPath === '/territory/index') {
                            //     this.$router.push({path:'indexTow'})
                            // } else if (this.$route.fullPath === '/territory/indexTow') {
                            //     this.$router.push({path:'index'})
                            // } else if (this.$route.fullPath === '/territory/institutions') {
                            //     this.$router.push({path:'institutionsTow'})
                            // } else if (this.$route.fullPath === '/territory/institutionsTow') {
                            //     this.$router.push({path:'institutions'})
                            // }
                            this.loading = false
                        }
                    }
                },500)
            },
            changeTreeRemove:function (val,oldval) {
                this.refreshNodeBy(this.parentNodeKey)
            },
            isseach:function (nval,oval) {
                // console.log(nval);

            }
        }
    }
</script>

<style lang="scss" module>
    .container {
        background: white;
        height: 100%;
        overflow: auto;
        .left {
            font-size: 18px;
            font-weight: bold;
            color: #000000;
            .search {
                width: 360px;

            }
            .type {
                em {
                    color: #d98f2f;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .first {
                color: #555555;
                font-size: 20px;
            }
            .font {
                margin-left: 20px;
                font-size: 14px;
                color: #555555;
            }
        }
        .right {
            margin-top: -20px;
            width: 100%;
            .header {
                width: 100%;
                padding-bottom: 6px;
                border-bottom: 2px dotted #e7eaec;

            }
            .body {
                overflow: auto;

            }
        }

        .noData {

        }
    }
</style>
<style>
    .el-container{
        height: 100%;
        padding: 20px;
        background: white;
    }
    #jurisdiction {
        background: white;
    }
    .el-main{
        background: white;
    }
    /*限制文字长度*/
    #jurisdiction #treeDiv .el-tree-node__content span {
        max-width: 240px;

        overflow: hidden;

        text-overflow: ellipsis;

        white-space: nowrap;
    }

    #jurisdiction #treeDiv .filter-tree .el-tree-node__expand-icon {
        display: none;
        margin-left: 0;
        font-size: 16px;
    }
    #jurisdiction #treeDiv .el-tree-node__label{
        font-size: 16px;
    }
    #jurisdiction #treeDiv .el-tree-node__label:before{
        content: "";
        display: inline-block;
        /*background: url("../../assets/images/jurisdiction2.png") no-repeat;*/
        /*background-size: 16px;*/
        width: 16px;
        height: 16px;
        margin:0 10px;

    }
    #jurisdiction #treeDiv .el-tree-node__content {
        /*display: flex;*/
        /*justify-content: space-between;*/
        height: 40px;
    }

    #jurisdiction #treeDiv .filter-tree .el-tree-node__content:before {
        content: "";
        display: inline-block;
        /*background: url("../../assets/images/role.png") no-repeat;*/
        /*background-size: 16px;*/
        width: 16px;
        height: 16px;
        margin: 20px;
    }

    #jurisdiction #inputData{
        width: 240px;
        border-radius: 0;
        text-align: center;
        color: #FF9901;
    }
    #jurisdiction .el-input__inner::-webkit-input-placeholder {
        text-align: center;
    }
    #jurisdiction .el-dialog__header {
        border-bottom: 2px dashed #DCDFE6;
        padding: 20px 0 20px 0;
        margin: 20px 20px 10px;
    }

    #jurisdiction .el-dialog__close {
        display: none;
    }

    #jurisdiction .el-dialog__body {
        padding-right: 100px;
    }
    #jurisdiction #inputSeach{
        padding: 0px;
        border-radius: 3px;
        background:#ededed;
        height: 30px;
        text-align:center;
    }
    #jurisdiction #el-rowInput .el-input{
        width: 348px;
        padding: 5px 5px;
        border: 1px solid #dedede;
    }

    #jurisdiction .formSave label{
        font-size: 16px;
        font-weight: bold;
        color: black;
    }
    #jurisdiction #elColImport .el-input{
        height: 30px;
    }
    #jurisdiction #elColImport #elInputImport{
        height: 30px !important;
    }
    #jurisdiction #effect{
        color:#303133;
        font-size: 14px;
        display: inline-block;
        padding:10px 20px;
        border:1px solid #DCDFE6;
        text-decoration: none;
        border-radius: 4px;
    }
    #jurisdiction #effect:hover{
        color: #1989FA ;
        background: #E6F1FC;
        border:1px solid #A3D0FD;
        transition: .2s;
    }
    #jurisdiction #effect2{
        color:#303133;
        font-size: 14px;
        display: inline-block;
        padding:10px 20px;
        border:1px solid #DCDFE6;
        text-decoration: none;
        border-radius: 4px;
    }
    #jurisdiction #effect2:hover{
        color: #1989FA ;
        background: #E6F1FC;
        border:1px solid #A3D0FD;
        transition: .2s;
    }
    #jurisdiction #effect.styleA{
        color: #1989FA ;
        background: #E6F1FC;
        border:1px solid #A3D0FD;
        transition: .2s;
    }
    jurisdiction #effect2.styleA{
        color: #1989FA ;
        background: #E6F1FC;
        border:1px solid #A3D0FD;
        transition: .2s;
    }
    #regionP{
        margin-left: 5px;
        padding:5px 14px;
        display: inline-block;
        font-size: 12px;
        border:1px solid #DB4DD7;
        color: #DB4DD7;
        border-radius: 4px
    }
    .btn_active{
        color: #409EFF;
        border-color:#c6e2ff;
        background-color: #ecf5ff;
    }
    .btn_inactive{
        color: #606266;
        border-color:#DCDFE6;
        background-color: #ffffff;
    }
    #update_jurisdictionManager .el-cascader__tags .el-tag{
        background: #FF9901 !important;
        color: white;
    }
    #update_jurisdictionManager .el-cascader__tags .el-tag .el-icon-close{
        background: #FF9901 !important ;
    }
    #update_jurisdictionManager .el-select {
        width: 100%;
    }
    #update_jurisdictionManager .el-select .el-tag{
        background: #FF9901 !important;
        border: none;
        color: white;
    }
    #update_jurisdictionManager .el-select .el-tag .el-icon-close{
        background: #FF9901 !important;
        color: white;
    }

    #add_jurisdictionManager .el-select{
        width: 100%;
    }
    #add_jurisdictionManager .el-select .el-tag{
        background: #FF9901 !important;
        border: none;
        color: white;
    }
    #add_jurisdictionManager .el-select .el-tag .el-icon-close{
        background: #FF9901 !important;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/pages/jurmanage/home.vue